document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('#shopify-section-template--24837281612063__section_3Q6j8d');
  if (!section) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6, rootMargin: '0px 0px -30% 0px' });

  io.observe(section);
});
